import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import VN from "../components/VN";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  Select,
  TextField,
  Button,
  Container,
  Typography,
  Box,
  InputLabel,
  MenuItem,
  FormControl,
  Autocomplete,
  Checkbox,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";
import { apiRequest } from "../components/Config";
import { UserDataContext } from "../components/UserDataContext";
import LocationSelect from "../components/LocationSelect";
import PasswordFields from "../components/PasswordFields";

export default function RegisterClient() {
  const { userData } = useContext(UserDataContext);
  const navigate = useNavigate();

  const [voivodeshipList, setVoivodeshipList] = useState([]);
  const [cities, setCities] = useState([]);

  useEffect(() => {
    apiRequest("voivodeship").then(setVoivodeshipList);
  }, []);

  const fetchCities = async (id) => {
    const res = await apiRequest(`cities/${id}`);
    setCities(res || []);
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Podaj poprawny email")
      .required("Email jest wymagany"),

    phone: Yup.string()
      .required("Telefon jest wymagany")
      .length(9, "Telefon musi mieć 9 cyfr"),

    fullName: Yup.string().required("Nazwisko i imię wymagane"),

    password: Yup.string().min(6, "Min. 6 znaków").required("Hasło wymagane"),

    passwordrepeat: Yup.string()
      .oneOf([Yup.ref("password")], "Hasła muszą być identyczne")
      .required("Powtórz hasło"),

    voivodeship: Yup.string().required("Wybierz województwo"),

    city: Yup.object().nullable().required("Wybierz miasto"),

    rodo: Yup.boolean().oneOf([true], "Wymagana zgoda"),
  });

  return (
    <div>
      <VN userData={userData} />
      <Container maxWidth="sm">
        <Box mt={5}>
          <Typography variant="h5">Rejestracja osoby szukającej</Typography>

          <Formik
            initialValues={{
              email: "",
              phone: "",
              fullName: "",
              password: "",
              passwordrepeat: "",
              voivodeship: "",
              city: null,
              rodo: false,
            }}
            validationSchema={validationSchema}
            onSubmit={async (values) => {
              await apiRequest("register", "POST", {
                ...values,
                city: values.city.id,
                accountType: 2,
              });
              navigate("/login", { state: { registered: true } });
            }}
          >
            {({ values, handleChange, setFieldValue, errors, touched }) => (
              <Form>
                <TextField
                  name="email"
                  label="Email"
                  fullWidth
                  margin="normal"
                  value={values.email}
                  onChange={handleChange}
                  error={touched.email && Boolean(errors.email)}
                  helperText={touched.email && errors.email}
                />

                <TextField
                  name="phone"
                  label="Telefon"
                  fullWidth
                  margin="normal"
                  value={values.phone}
                  onChange={(e) =>
                    setFieldValue(
                      "phone",
                      e.target.value.replace(/\D/g, "").slice(0, 9),
                    )
                  }
                  error={touched.phone && Boolean(errors.phone)}
                  helperText={touched.phone && errors.phone}
                />

                <TextField
                  name="fullName"
                  label="Nazwisko i Imię"
                  fullWidth
                  margin="normal"
                  value={values.fullName}
                  onChange={handleChange}
                  error={touched.fullName && Boolean(errors.fullName)}
                  helperText={touched.fullName && errors.fullName}
                />

                <PasswordFields
                  values={values}
                  handleChange={handleChange}
                  errors={errors}
                  touched={touched}
                />

                <LocationSelect
                  values={values}
                  setFieldValue={setFieldValue}
                  errors={errors}
                  touched={touched}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name="rodo"
                      checked={values.rodo}
                      onChange={handleChange}
                      color="primary"
                    />
                  }
                  label="Wyrażam zgodę na przetwarzanie danych (RODO)"
                />

                {touched.rodo && errors.rodo && (
                  <FormHelperText error>{errors.rodo}</FormHelperText>
                )}
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 2 }}
                >
                  Zarejestruj
                </Button>
              </Form>
            )}
          </Formik>
        </Box>
      </Container>
    </div>
  );
}
